"use client";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { LoaderCircle } from "lucide-react";
import { useState } from "react";
import { client } from "@/lib/hono";
import toast from "@/lib/toast";
import { useQueryClient } from "@tanstack/react-query";
import { useStorageQuery } from "../../hooks/storageQueryProvider";
import { t } from "@/lib/localization";

export default function CreateFolderModal() {
    const { createFolderModalOpen, setCreateFolderModalOpen, parentFolder } =
        useStorageQuery();

    const [isPending, setIsPending] = useState(false);

    const queryClient = useQueryClient();

    const submitHandler = async (e: any) => {
        e.preventDefault();

        setIsPending(true);

        const name = e.target.folderName.value;

        const res = await client.api.storage.folder.create.$post({
            json: {
                name,
                parentId: parentFolder?.id,
            },
        });

        if (!res.ok) {
            const error = await res.text();
            console.log(error);
            toast.error(t("toast.error.default"), {
                keyName: "toast.error.default",
            });
        } else {
            const data = await res.json();
            console.log(data);

            queryClient.invalidateQueries({
                queryKey: ["get-storage-folders"],
            });
            toast.success(t("toast.success.create-folder"), {
                keyName: "toast.success.create-folder",
            });
            setCreateFolderModalOpen(false);
            setIsPending(false);
        }
    };

    return (
        <Dialog
            open={createFolderModalOpen}
            onOpenChange={(open) => setCreateFolderModalOpen(open)}
        >
            <DialogContent className="sm:max-w-[380px]">
                <DialogHeader>
                    <DialogTitle>
                        {t("storage.create-folder-modal.header.title", undefined, undefined)}
                    </DialogTitle>
                    <DialogDescription>
                        {t("storage.create-folder-modal.header.description", undefined, undefined)}
                    </DialogDescription>
                </DialogHeader>
                <form onSubmit={submitHandler}>
                    <div className="py-4">
                        <div className="flex flex-col gap-2">
                            <Label htmlFor="folderName" className="text-right">
                                {t("storage.create-folder-modal.folder-name-input.label", undefined, undefined)}
                            </Label>
                            <Input id="folderName" defaultValue="" required />
                        </div>
                    </div>
                    <DialogFooter className="mt-4">
                        <Button
                            disabled={isPending}
                            type="submit"
                            className="flex w-full justify-center items-center"
                        >
                            {isPending ? (
                                <LoaderCircle className="size-4 text-white animate-spin" />
                            ) : (
                                t("storage.create-folder-modal.submit-btn", undefined, undefined)
                            )}
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
}
